<template>
  <v-card max-width="296" class="mx-auto mb-3">
    <!-- Head -->
    <v-list-item>
        <v-list-item-avatar>
          <v-img :src="`https://api.sp0m.co/`+photo"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">{{this.title}}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <!-- Links -->
    <v-card-actions>
        <v-btn max-width="70" min-width="70" small text color="primary" :href="en" target="_blank">
          {{ $t("ScamaCard.English") }}
        </v-btn>
        <v-divider vertical></v-divider>
        <v-btn max-width="70" min-width="70" small text color="primary" :href="fr" target="_blank">
          {{ $t("ScamaCard.French") }}
        </v-btn>
         <v-divider vertical></v-divider>
        <v-btn max-width="70" min-width="70" small text color="primary" :href="ar" target="_blank">
          {{ $t("ScamaCard.Arabic") }}
        </v-btn>
         <v-divider vertical></v-divider>
        <v-btn max-width="70" min-width="70" small text color="primary" :href="il" target="_blank">
          {{ $t("ScamaCard.Hebrew") }}
        </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ScamaCard from "@/apis/User";

export default {
  name : 'ScamaCard',
  data(){
    return {
      ScamaCard: null
    }
  },
  props : {
    title : String,
    photo : String,
      ar : String,
      en : String,
      fr : String,
      il : String
  }
};
</script>